import { useEffect, useState } from "react";

interface ThirdPartyScriptProps {
  gtagTrackingId?: string;
}

const ThirdPartyScript = ({ gtagTrackingId }: ThirdPartyScriptProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `
                !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window,document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '1010148886929063'); 
              fbq('track', 'PageView');
      `,
        }}
      ></script>
      {gtagTrackingId && (
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtagTrackingId}');`,
          }}
        />
      )}
      <noscript>
        <img
          alt=""
          height="1"
          width="1"
          src="https://www.facebook.com/tr?id=1010148886929063&ev=PageView&noscript=1"
        />
        {gtagTrackingId && (
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtagTrackingId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="Google Tag Manager"
          ></iframe>
        )}
      </noscript>
    </>
  );
};

export default ThirdPartyScript;
